import { Button, Checkbox, Col, Flex, Modal, notification, Tooltip } from 'antd';
import { SettingOutlined } from '@ant-design/icons';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import convertTo2DArray from '@/utils/convert2double';

export interface ColSetOption {
  label: string;
  key: string;
  disabled?: boolean;
}

export interface ColSetButtonProps {
  options: ColSetOption[];
  value?: ColSetOption[];
  onOk?: (val: ColSetOption[]) => void;
  onClose?: () => void;
  colQty?: number;
}

const ColSetButton: FC<ColSetButtonProps> = ({
  options,
  value,
  onOk,
  onClose,
  colQty = 7,
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [draftKeys, setDraftKeys] = useState<string[]>([]);

  useEffect(() => {
    if (open) {
      setDraftKeys((value ?? options).map(item => item.key));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const handleOk = () => {
    if (draftKeys.length === 0) {
      notification.error({ message: t('common.leastSetOneCol') })
      return;
    }
    const selected = options.filter(option => draftKeys.includes(option.key));
    setOpen(false);
    onOk?.(selected);
  };

  const handleClose = () => {
    setOpen(false);
    onClose?.();
  };

  return (
    <>
      <Tooltip title={t('common.colSet')}>
        <Button icon={<SettingOutlined />} onClick={() => setOpen(true)} />
      </Tooltip>
      <Modal
        title={t('common.colSet')}
        open={open}
        onOk={handleOk}
        onCancel={handleClose}
        width={'60vw'}
      >
        <Flex vertical style={{ width: '100%' }}>
          <div style={{ marginTop: 15, marginBottom: 10, width: '100%' }}>
            <Checkbox
              indeterminate={draftKeys.length > 0 && draftKeys.length < options.length}
              checked={options.length > 0 && draftKeys.length === options.length}
              onChange={e => {
                setDraftKeys(e.target.checked ? options.map(option => option.key) : []);
              }}
            >
              {t('common.selectAll')}
            </Checkbox>
          </div>
          <Checkbox.Group
            style={{ width: '100%' }}
            value={draftKeys}
            onChange={values => setDraftKeys(values as string[])}
          >
            <Flex justify="space-between" style={{ width: '100%' }}>
              {
                convertTo2DArray(options, colQty).map((datas, cols) => (
                  <div key={cols}>
                    {
                      datas.map((option, index) => (
                        <Col key={`${cols}-${index}`} style={{ marginBottom: 4 }}>
                          <Checkbox value={option.key} disabled={option.disabled}>{option.label}</Checkbox>
                        </Col>
                      ))
                    }
                  </div>
                ))
              }
            </Flex>
          </Checkbox.Group>
        </Flex>
      </Modal>
    </>
  );
};

export default ColSetButton;
